<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.38272 1.75501C7.59605 1.19234 8.40338 1.19234 8.61738 1.75501L9.99738 5.57767C10.0941 5.83101 10.34 5.99967 10.6147 5.99967H14.0061C14.6327 5.99967 14.906 6.77968 14.4134 7.16167L12 9.33301C11.8919 9.41611 11.8129 9.53133 11.7744 9.66211C11.7358 9.7929 11.7397 9.93255 11.7854 10.061L12.6667 13.7963C12.8814 14.3963 12.1867 14.9117 11.6614 14.5423L8.38338 12.4623C8.27113 12.3834 8.13726 12.3411 8.00005 12.3411C7.86284 12.3411 7.72897 12.3834 7.61672 12.4623L4.33872 14.5423C3.81405 14.9117 3.11872 14.3957 3.33338 13.7963L4.21472 10.061C4.26044 9.93255 4.26429 9.7929 4.22572 9.66211C4.18716 9.53133 4.10816 9.41611 4.00005 9.33301L1.58672 7.16167C1.09338 6.77968 1.36805 5.99967 1.99338 5.99967H5.38472C5.51825 6.00012 5.64876 5.96001 5.759 5.88466C5.86923 5.8093 5.95399 5.70225 6.00205 5.57767L7.38272 1.75501Z"
      stroke="#FFDA58"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
